import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';

import AthleteAttendancePageHeader from './components/AthleteAttendancePageHeader';
import AthleteAttendanceTable from './components/AthleteAttendanceTable';
import { SearchFilters } from './types';

const AthleteAttendance = (): JSX.Element => {
  const initialSearchFiltersValue: SearchFilters = {
    dateRange: [null, null],
    athleteStatuses: [],
    eventTypes: [],
  };

  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('-checkedInEvents');

  return (
    <>
      <AthleteAttendancePageHeader
        initialSearchFiltersValue={initialSearchFiltersValue}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        orderingValue={orderingValue}
      />

      <AthleteAttendanceTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default AthleteAttendance;
